(function ($) {
    $.fn.selectAllCheckBoxes = function () {
        if ($('input:checked', this).length > 0) {
            $('input:checkbox', this).prop('checked', '').change();
        } else {
            $('input:checkbox', this).prop('checked', 'checked').change();
        }
        return $(this)
    };
}(jQuery));